import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCircle2, Loader2, ShieldCheck } from "lucide-react";
import { fetchBF, fetchConsent, signConsent } from "@/lib/bf";
import BFGdprNotice from "./BFGdprNotice";
import { saveReg } from "./BFGdprGate";

const ROWS = [["salon", "Salon"], ["admin_name", "Administrator"], ["cui", "CUI"], ["address", "Adresă livrare"], ["postal", "Cod poștal"], ["email", "E-mail"], ["phone", "Telefon"]];

export default function BFConsent() {
  const { t } = useParams();
  const nav = useNavigate();
  const [x, setX] = useState(null);
  const [cfg, setCfg] = useState({});
  const [f, setF] = useState({ gdpr: false, confidential: false, marketing: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetchConsent(t).then(setX).catch(() => setErr("Link invalid sau expirat. Scrie-ne pe WhatsApp și îți trimitem unul nou."));
    fetchBF().then(setCfg).catch(() => {});
  }, [t]);
  const set = (k) => (e) => { setErr(""); setF({ ...f, [k]: e.target.checked }); };
  const submit = (e) => {
    e.preventDefault();
    if (!f.gdpr || !f.confidential) return setErr("Bifează acordul GDPR și angajamentul de confidențialitate");
    setBusy(true); setErr("");
    signConsent(t, f).then((r) => { const { id, ...info } = r; saveReg(id, info); setX({ ...x, signed: true }); })
      .catch(() => setErr("Nu am putut salva acordul. Încearcă din nou.")).finally(() => setBusy(false));
  };
  return (
    <div className="bf-app bf-gate" data-testid="bf-consent-page">
      <div className="bf-gate-wrap">
        {!x && <div className="bf-gate-card"><p className="bf-gate-sub" data-testid="bf-consent-msg">{err || "Se încarcă…"}</p></div>}
        {x?.signed && (
          <div className="bf-gate-card bf-gate-done" data-testid="bf-consent-done">
            <h2><CheckCircle2 size={22} /> Mulțumim, {x.salon} este înscris</h2>
            <p className="bf-gate-sub">Acordul a fost salvat. Poți vedea ofertele Black Friday oricând de pe acest telefon.</p>
            <button type="button" onClick={() => nav(window.location.pathname.startsWith("/blackfriday") ? "/blackfriday" : "/")} data-testid="bf-consent-offers">Vezi ofertele</button>
          </div>
        )}
        {x && !x.signed && (
          <form className="bf-gate-card" onSubmit={submit} data-testid="bf-consent-form">
            <span className="bf-kicker">Beauty Trends · Black Friday 2026</span>
            <h2><ShieldCheck size={22} /> Confirmă datele salonului</h2>
            <p className="bf-gate-sub">Comanda ta a fost preluată din WhatsApp. Ca să o putem factura și livra, confirmă datele și acordul de mai jos.</p>
            <dl className="bf-consent-data">{ROWS.filter(([k]) => x[k]).map(([k, l]) => <div key={k}><dt>{l}</dt><dd data-testid={`bf-consent-${k}`}>{x[k]}</dd></div>)}</dl>
            <details className="bf-gdpr"><summary>Citește nota de informare GDPR</summary><BFGdprNotice cfg={cfg} /></details>
            <label className="bf-lead-consent"><input type="checkbox" checked={f.gdpr} onChange={set("gdpr")} data-testid="bf-consent-gdpr" />
              <span>Am citit nota de informare și sunt de acord cu prelucrarea datelor pentru preluarea, facturarea și livrarea comenzilor Black Friday. <b>(obligatoriu)</b></span></label>
            <label className="bf-lead-consent bf-conf"><input type="checkbox" checked={f.confidential} onChange={set("confidential")} data-testid="bf-consent-confidential" />
              <span>Mă angajez să păstrez <b>confidențiale</b> ofertele, prețurile și condițiile Black Friday primite de la VS Beauty Trends. <b>(obligatoriu)</b></span></label>
            <label className="bf-lead-consent"><input type="checkbox" checked={f.marketing} onChange={set("marketing")} data-testid="bf-consent-marketing" />
              <span>Vreau să primesc pe e-mail/WhatsApp oferte și noutăți Beauty Trends (opțional).</span></label>
            {err && <p className="bf-lead-err" data-testid="bf-consent-error">{err}</p>}
            <button type="submit" disabled={busy} data-testid="bf-consent-submit">{busy && <Loader2 size={16} className="animate-spin" />} Confirm și semnez</button>
          </form>
        )}
      </div>
    </div>
  );
}
